import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-mid px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg6429tfa1g">
        <h2 className="text-center text-lg font-extrabold uppercase text-white sm:text-3xl" data-id="element-20" data-mp="av39r46tfp6f">
          🎁 5 professional bonuses included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="fslhir93jycu">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-gold bg-white px-2.5 py-2 shadow-sm" data-id="element-22" data-mp="1tc0xqgzb28c">
              <h3 className="text-xs font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-sm" data-id="element-23" data-mp="3o1lf0qlfzjix">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-heading text-xs font-semibold text-mid sm:text-sm" data-id="element-24" data-mp="3t2j65sofjnwk">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-sm leading-snug sm:text-base" data-id="element-25" data-mp="1r9l9flrj8b6c">{bonus.body}</p>
              <p className="mt-1 font-heading text-xs font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-26" data-mp="3idwp7m125gma">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}